import { Components, Theme } from "@mui/material/styles";

const MuiCssBaseline: Components<Theme>["MuiCssBaseline"] = {
  styleOverrides: {
    body: {
      backgroundColor: "#f8ecde",
    },
  },
};

export default MuiCssBaseline;
